import axiosInstance from '../../axios/instance'
import { getToken } from '../../helpers/get-token'
import isAppFreeByCompanyName from '../micro/get_client_application_by_company_name'
import isAppFreeByProductName from '../micro/get_client_application_by_name'
import isAppFreeByUrl from '../micro/get_client_application_by_url'
import isEmailFree from '../micro/get_client_application_or_account_by_email'


export async function validateApplication(values) {
    const { product_url, product_name, company_name, email } = values;

    const [isUserEmailFree, isProductNameFree, isProductUrlFree, isCompanyNameFree] = await Promise.all([
        isEmailFree(email),
        isAppFreeByProductName(product_name),
        isAppFreeByUrl(product_url),
        isAppFreeByCompanyName(company_name)
    ]);

    if (!isUserEmailFree) {
        return {
            success: false,
            message: `Email "${email}" is already taken`,
            modalMessage: `It seems that your email "${email}" already exists in our system. <br/> Please contact your team so that one of your team members can grant you access. <br/> If you believe no one from your team actually registered your product, please contact us at <a href="mailto:support@revbox.com">support@revbox.com</a>.`
        }
    }

    if (!isProductNameFree) {
        return {
            success: false,
            message: `Product name "${product_name}" is already taken`,
            modalMessage: `It seems that your product name "${product_name}" already exists in our system. <br/> Please contact your team so that one of your team members can grant you access. <br/> If you believe no one from your team actually registered your product, please contact us at <a href="mailto:support@revbox.com">support@revbox.com</a>.`
        }
    }

    if (!isCompanyNameFree) {
        return {
            success: false,
            message: `Company name "${company_name}" is already taken`,
            modalMessage: `It seems that your company name "${company_name}" already exists in our system. <br/> Please contact your team so that one of your team members can grant you access. <br/> If you believe no one from your team actually registered your product, please contact us at <a href="mailto:support@revbox.com">support@revbox.com</a>.`
        }
    }

    if (!isProductUrlFree) {
        return {
            success: false,
            message: `Product URL "${product_url}" is already registered`
        }
    }

    return {
        success: true,
        message: 'Application is valid'
    }
}

export async function postNewApplication(values, isOnboarding = false) {
    try {
        const token = getToken()
        const publisher_id = window.location.search.split('=')[1]
        const baseUrl = '/api/client-applications'
        const url = isOnboarding ? `${baseUrl}` : `${baseUrl}/new`
        const data = { ...values, publisher_id }

        const response = await axiosInstance.post(url, data, {
            headers: {
                Authorization: token
            }
        })
        return response?.data
    } catch (error) {
        console.log(error)
        throw error
    }
}
